export default __webpack_public_path__ + "static/media/snowyforest.0e9629d6.png";